import { render, staticRenderFns } from "./RefundView.vue?vue&type=template&id=5376bb31&scoped=true&"
import script from "./RefundView.vue?vue&type=script&lang=js&"
export * from "./RefundView.vue?vue&type=script&lang=js&"
import style0 from "./RefundView.vue?vue&type=style&index=0&id=5376bb31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5376bb31",
  null
  
)

export default component.exports